var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "message-box dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickOutSide.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-box" }, [
        _c("div", { staticClass: "section dialog-header" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("myPage.userDeleteDialog.title")))]),
          _c("h3", [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("myPage.userDeleteDialog.description1"))),
            ]),
            _c("span", { staticClass: "color-danger" }, [
              _vm._v(_vm._s(_vm.$t("myPage.userDeleteDialog.description2"))),
            ]),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("myPage.userDeleteDialog.description3"))),
            ]),
          ]),
        ]),
        _vm.existsNolaPublishingUser || _vm.existsNolaNovelUser
          ? _c("div", { staticClass: "section dialog-body" }, [
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("myPage.userDeleteDialog.relatedServicesNotice")
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "related-services" }, [
                _vm.existsNolaNovelUser
                  ? _c("div", { staticClass: "font-bold" }, [
                      _vm._v(
                        _vm._s(_vm.$t("myPage.userDeleteDialog.nolaNovel"))
                      ),
                    ])
                  : _vm._e(),
                _vm.existsNolaPublishingUser
                  ? _c("div", { staticClass: "font-bold" }, [
                      _vm._v(
                        _vm._s(_vm.$t("myPage.userDeleteDialog.nolaPublishing"))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "section dialog-body" }, [
          _c("div", [
            _vm._v(_vm._s(_vm.$t("myPage.userDeleteDialog.confirmNotice"))),
          ]),
          _c(
            "div",
            { staticClass: "checkbox", on: { click: _vm.onClickCheckbox } },
            [
              _c("checkbox-icon", {
                staticClass: "form-input",
                attrs: { isChecked: _vm.confirmed, fill: "#389bff" },
              }),
              _c("span", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.$t("myPage.userDeleteDialog.checkboxLabel"))),
              ]),
            ],
            1
          ),
          _c("div", [
            _c(
              "div",
              { staticClass: "color-danger" },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("myPage.userDeleteDialog.contactNoticePrefix")
                    ) +
                    " "
                ),
                _c(
                  "router-link",
                  {
                    attrs: { to: "/contact" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.onClickContact.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.contact")))]
                ),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("myPage.userDeleteDialog.contactNoticeSuffix")
                    ) +
                    " "
                ),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "section button-area" }, [
          _c(
            "button",
            {
              staticClass: "button font-bold",
              on: { click: _vm.onNegativeClick },
            },
            [_vm._v(_vm._s(_vm.negative))]
          ),
          _c(
            "button",
            {
              staticClass: "button danger font-bold",
              attrs: { disabled: !_vm.confirmed },
              on: { click: _vm.onPositiveClick },
            },
            [_vm._v(_vm._s(_vm.positive))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }